/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { StabilityPool, StabilityPoolInterface } from "../StabilityPool";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_Asset",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_VSTLoss",
        type: "uint256",
      },
    ],
    name: "AssetGainWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "AssetSent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newBorrowerOperationsAddress",
        type: "address",
      },
    ],
    name: "BorrowerOperationsAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newCommunityIssuanceAddress",
        type: "address",
      },
    ],
    name: "CommunityIssuanceAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newDefaultPoolAddress",
        type: "address",
      },
    ],
    name: "DefaultPoolAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_P",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_S",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_G",
        type: "uint256",
      },
    ],
    name: "DepositSnapshotUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "_currentEpoch",
        type: "uint128",
      },
    ],
    name: "EpochUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_G",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "_epoch",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "_scale",
        type: "uint128",
      },
    ],
    name: "G_Updated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_P",
        type: "uint256",
      },
    ],
    name: "P_Updated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_S",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "_epoch",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "_scale",
        type: "uint128",
      },
    ],
    name: "S_Updated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "_currentScale",
        type: "uint128",
      },
    ],
    name: "ScaleUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newSortedTrovesAddress",
        type: "address",
      },
    ],
    name: "SortedTrovesAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_newBalance",
        type: "uint256",
      },
    ],
    name: "StabilityPoolAssetBalanceUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_newBalance",
        type: "uint256",
      },
    ],
    name: "StabilityPoolVSTBalanceUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_newSystemStake",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
    ],
    name: "StakeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_P",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_G",
        type: "uint256",
      },
    ],
    name: "SystemSnapshotUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newTroveManagerAddress",
        type: "address",
      },
    ],
    name: "TroveManagerAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_newDeposit",
        type: "uint256",
      },
    ],
    name: "UserDepositChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_VSTA",
        type: "uint256",
      },
    ],
    name: "VSTAPaidToDepositor",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newVSTTokenAddress",
        type: "address",
      },
    ],
    name: "VSTTokenAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newAddress",
        type: "address",
      },
    ],
    name: "VaultParametersBaseChanged",
    type: "event",
  },
  {
    inputs: [],
    name: "DECIMAL_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ETH_REF_ADDRESS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "P",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SCALE_FACTOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "STABILITY_POOL_NAME_BYTES",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "borrowerOperations",
    outputs: [
      {
        internalType: "contract IBorrowerOperations",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "communityIssuance",
    outputs: [
      {
        internalType: "contract ICommunityIssuance",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentEpoch",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentScale",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "depositSnapshots",
    outputs: [
      {
        internalType: "uint256",
        name: "S",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "P",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "G",
        type: "uint256",
      },
      {
        internalType: "uint128",
        name: "scale",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "epoch",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "deposits",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    name: "epochToScaleToG",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    name: "epochToScaleToSum",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAssetBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAssetType",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCompoundedTotalStake",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
    ],
    name: "getCompoundedVSTDeposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
    ],
    name: "getDepositorAssetGain",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
    ],
    name: "getDepositorVSTAGain",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getEntireSystemColl",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemColl",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getEntireSystemDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemDebt",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getNameBytes",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "getTotalVSTDeposits",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lastAssetError_Offset",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lastVSTAError",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lastVSTLossError_Offset",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_debtToOffset",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_collToAdd",
        type: "uint256",
      },
    ],
    name: "offset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "provideToSP",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "receivedERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_assetAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vstTokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_communityIssuanceAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vestaParamsAddress",
        type: "address",
      },
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vaultParams",
        type: "address",
      },
    ],
    name: "setVestaParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "sortedTroves",
    outputs: [
      {
        internalType: "contract ISortedTroves",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "systemSnapshots",
    outputs: [
      {
        internalType: "uint256",
        name: "S",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "P",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "G",
        type: "uint256",
      },
      {
        internalType: "uint128",
        name: "scale",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "epoch",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalStakes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "troveManager",
    outputs: [
      {
        internalType: "contract ITroveManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vestaParams",
    outputs: [
      {
        internalType: "contract IVestaParameters",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vstToken",
    outputs: [
      {
        internalType: "contract IVSTToken",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_upperHint",
        type: "address",
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address",
      },
    ],
    name: "withdrawAssetGainToTrove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdrawFromSP",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type StabilityPoolConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: StabilityPoolConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class StabilityPool__factory extends ContractFactory {
  constructor(...args: StabilityPoolConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<StabilityPool> {
    return super.deploy(overrides || {}) as Promise<StabilityPool>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): StabilityPool {
    return super.attach(address) as StabilityPool;
  }
  override connect(signer: Signer): StabilityPool__factory {
    return super.connect(signer) as StabilityPool__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StabilityPoolInterface {
    return new utils.Interface(_abi) as StabilityPoolInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): StabilityPool {
    return new Contract(address, _abi, signerOrProvider) as StabilityPool;
  }
}
